<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from '../../../../../services/i18n';
	import { gen2Request } from '../../../../../services/gen_2_http_reqs';
	//Stores
	//Helpers
	import { real_id } from '../../../../../helpers/interface_helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	//Types
	import type { SettingRequest } from '../../../../../types/requests/settings/setting';
	//Design system components
	import { Button, Radio, Text, toast } from '@Shelly/shelly-design-system';
	import SettingGuide from '../../../SettingGuide.svelte';

	export let device;
	export let deferSave = false;

	const id = real_id(device.id);
	const channel = device.channel;

	const inputOptions = ['button', 'switch', 'disabled'];
	const _input_options_i18n = [
		$format('virtual_component_label_button', { default: 'Button' }),
		$format('label_switch', { default: 'Switch' }),
		$format('option_disabled', { default: 'Disabled' }),
	]; //using this already done translation keys just to not add new ones but if needed i will

	let settings = readDeviceSettings(id);
	export let inputType = settings?.[`input:${channel}`]?.type;
	let loading = false;
	let cacheInputType = inputType;

	const setInputType = (value) => {
		inputType = value;
	};

	const sentRequest = async () => {
		if (cacheInputType !== inputType) {
			loading = true;
			let params = { id: channel, config: { type: inputType } };

			try {
				const res: SettingRequest = await gen2Request(device, 'Input.SetConfig', params);

				if (res.isok) {
					settings[`input:${channel}`].type = inputType;
					cacheInputType = inputType;

					toast.open({
						type: 'success',
						title: $format('input_type_scc_toast', {
							values: { mode_value: inputType },
						}),
					});
				} else {
					toast.open({
						type: 'danger',
						title: $format('input_type_err_toast') || 'Error! Could not change input mode.',
					});
					inputType = cacheInputType;
					throw new Error('Could not change input mode.');
				}

				loading = false;
			} catch (error) {
				console.error(error);
				loading = false;
			}
		}
	};
</script>

<SettingGuide
	text={$format('settings_guide_wall_display_input_type', {
		default:
			'Choose whether the wall switch acts as a button, a switch, or is disabled.',
	})}
/>

<Text element="h2" styleType="h2" class="mb-s">
	{$format('input_type_desc', { default: 'Set input type' })}
</Text>

{#each inputOptions as option, index}
	<Radio
		size="m"
		selected={option}
		value={inputType}
		on:click={() => setInputType(option)}
		id="radio-tgvgvu2"
	>
		{capFirstChar(_input_options_i18n[index])}
	</Radio>
{/each}

{#if !deferSave}
	<Button class="mt-s" {loading} size="m" width="full" on:click={sentRequest}>
		{$format('button_save')}
	</Button>
{/if}
